/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthEmrDocumentSelectionRequest
 */
export interface UpdatePalReauthEmrDocumentSelectionRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePalReauthEmrDocumentSelectionRequest
     */
    is_selected: boolean;
}

/**
 * Check if a given object implements the UpdatePalReauthEmrDocumentSelectionRequest interface.
 */
export function instanceOfUpdatePalReauthEmrDocumentSelectionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_selected" in value;

    return isInstance;
}

export function UpdatePalReauthEmrDocumentSelectionRequestFromJSON(json: any): UpdatePalReauthEmrDocumentSelectionRequest {
    return UpdatePalReauthEmrDocumentSelectionRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthEmrDocumentSelectionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_selected': json['is_selected'],
    };
}

export function UpdatePalReauthEmrDocumentSelectionRequestToJSON(value?: UpdatePalReauthEmrDocumentSelectionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_selected': value.is_selected,
    };
}

